import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import { z } from "zod";
import { taskTypes } from "../drizzle/taskTypes.js";
export const taskTypeSchema = createSelectSchema(taskTypes, {
    key: (schema) => schema.meta({
        description: "Unique key identifying the task type (also the primary key)",
        example: "cost_estimate",
    }),
    // Use z.coerce.date() for date fields because JSON serialization converts Date objects to ISO strings
    createdAt: () => z.coerce.date().meta({
        description: "Task type creation timestamp",
        example: "2024-01-15T10:30:00.000Z",
    }),
    updatedAt: () => z.coerce.date().meta({
        description: "Task type last update timestamp",
        example: "2024-01-15T10:30:00.000Z",
    }),
    title: (schema) => schema.meta({
        description: "Task type title",
        example: "Invoice Processing",
    }),
    description: (schema) => schema.meta({
        description: "Task type description",
        example: "Process and validate incoming invoices",
    }),
}).describe("Task type object");
// Base schema using callbacks - stays in sync with Drizzle column types
const baseCreateTaskTypeSchema = createInsertSchema(taskTypes, {
    key: (schema) => schema.meta({
        description: "Unique key identifying the task type (also the primary key)",
        example: "cost_estimate",
    }),
    title: (schema) => schema.min(1, "Bitte gib einen Titel an").meta({
        description: "Task type title",
        example: "Invoice Processing",
    }),
    description: (schema) => schema
        .meta({
        description: "Task type description",
        example: "Process and validate incoming invoices",
    })
        .nullable(),
});
// Fix drizzle-zod bug: callbacks for nullable fields lose .optional() wrapper
// We extend the base schema to add .optional() to nullable fields
export const createTaskTypeSchema = baseCreateTaskTypeSchema
    .extend({
    description: baseCreateTaskTypeSchema.shape.description.optional(),
})
    .describe("Create task type request body");
